import React, { useEffect, useMemo, useState } from 'react';
import { useAPI } from '../../shared/services/api/API';
import { WASHUB_CONSTANTS } from '../../shared/Constants';
import { Box, Button, Grid, Link, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const DeliveryToEmp = () => {
  const { httpPost, handleAlertBar } = useAPI();
  const [qrCodes, setQrCodes] = useState(['']);
  const qrRef = React.useRef<(HTMLInputElement | null)[]>([]);
  const [disabledIndexes, setDisabledIndexes] = useState<number[]>([]);

  const handleEmpDelivery = async () => {
    const payload: any = {
      barCodeList: [...qrCodes],
    };
    httpPost(
      `${WASHUB_CONSTANTS.API_URLS.COLLECTION_CENTER_RECEIVE_DELIVERY_POST}`,
      payload,
    ).then((response) => {
      if (response.status === 200) {
        handleAlertBar('success', 'Delivery to employee received successfully');
        setQrCodes(['']);
        qrRef.current[0]?.focus();
      } else {
        if (response.data.error) {
          if (response.data.error) {
            if (response.data.message === 'INVALID_OPERATION') {
              handleAlertBar('error', 'Invalid operation');
            }
          }
        }
      }
    });
  };
  const removeQrCode = (index: number, qrCode: string) => {
    const updatedQrCodes = [...qrCodes];
    if (updatedQrCodes.length === 1) {
      setQrCodes(['']);
      qrRef.current[0]?.focus();
      setDisabledIndexes([]);
    }
    setDisabledIndexes((prev) =>
          prev
            .filter((i) => i !== index)          
            .map((i) => (i > index ? i - 1 : i))   
        );
    setQrCodes(updatedQrCodes.filter((_, i) => i !== index));
  };

  const handleQrScan = (index: number, value: string) => {
    const updatedQrCodes = [...qrCodes];
    updatedQrCodes[index] = value;
    setDisabledIndexes((prev) => [...prev, index]);
    if (index === qrCodes.length - 1 && value) {
      updatedQrCodes.push('');
      setTimeout(() => {
        qrRef.current[index + 1]?.focus();
      }, 1000);
      setQrCodes(updatedQrCodes);
    }
  };

  useEffect(() => {
    qrRef.current[0]?.focus();
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            color={'primary'}
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Delivery to Employee
          </Typography>
        </Grid>
      </Grid>

      <div style={{ margin: '5px 15px', borderTop: '2px solid #25BCCA' }}></div>
      <Grid
        container
        display={'flex'}
        flexDirection={'row'}
        className="p-4"
        sx={{ maxHeight: '30vh', overflow: 'auto' }}
      >
        <Grid item xs={12} sm={12} md={7} lg={7}>
          {qrCodes?.map((qr: string, index: number) => (
            <Grid
              container
              key={index}
              display={'flex'}
              flexDirection={'row'}
              className="mb-4"
            >
              <Grid item xs={6} sm={6} md={9} lg={9}>
                <input
                  type="text"
                  style={{ width: '50%' }}
                  data-index={index}
                  value={qr}
                  ref={(el) => (qrRef.current[index] = el)}
                  placeholder="Scan the Bar Code..."
                  onChange={(e) => handleQrScan(index, e.target.value)}
                  disabled={disabledIndexes.includes(index)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3}>
                {qr && (
                  <Link component="button" title={'Remove'}>
                    <CloseIcon
                      className="ms-4 mb-1"
                      color="error"
                      fontSize="small"
                      onClick={() => removeQrCode(index, qr)}
                    />
                  </Link>
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <div>{`Total Receive Delivery Order scan: ${qrCodes.filter((qr: string) => qr !== '').length}`}</div>
        </Grid>
      </Grid>
      <div className="d-flex justify-content-end me-2">
        <Button
          variant="contained"
          className="me-2"
          onClick={() => {
            handleEmpDelivery();
          }}
        >
          Delivery to Employee
        </Button>
      </div>
    </div>
  );
};
